export const withImmutableData =
  <T>(copyObjFn: (value: T) => T) =>
  (transformFn: (value: T) => T) =>
  (value: T): T => {
    const clonedValue = copyObjFn(value);
    return transformFn(clonedValue);
  };
